import _ from 'lodash'

Controller.$inject = ['$state']
function Controller($state) {
  const ctrl = this
  let count = 0

  ctrl.$onInit = () => {
    count = _.reduce(ctrl.locations, (total, location) => total + location.Quantity, 0)
  }

  ctrl.countAll = () => {
    return count
  }

  ctrl.edit = () => {
    $state.go('^.locationsEdit', {
      locations: ctrl.locations,
      part: ctrl.part
    })
  }
  ctrl.retire = () => {
    $state.go('^.locationsRerire', {
      locations: ctrl.locations,
      part: ctrl.part
    })
  }
}

export default Controller